import React from 'react'
import Tabs from '../../../components/ui/Tabs'
import LayoutDashBoard from '../../../components/layoutDashBoard/LayoutDashBoard'
import { useMyContracts } from './hook/useMyContracts'

const MyContracts = () => {
    const { tabs } = useMyContracts()

    return (
        <LayoutDashBoard activeMenu={'Contratos'}>
            <Tabs
                tabs={tabs}
            />
        </LayoutDashBoard>
    )
}

export default MyContracts